import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";



export const fetchPRs = createAsyncThunk(
  "pr/fetchPRs",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    type,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    type?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any[];
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (type === "tag") params.append("type", "tag");
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      const filterPayload = FilterBuilder(filters ?? []);

      const body = {
        filters: filterPayload,
        ...(type === "tag" ? { type: "tag" } : {}),
      };

      const response: any = await Axios.post(
        `${API_ENDPOINT?.PURCHASE_MANAGEMENT?.PURCHASE_REQUEST?.LIST}?${params.toString()}`,
        body
      );
      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      throw new Error("Failed to fetch Purchase Request List");
    }
  }
);

export const exportPurchaseRequestCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: {
    filterField: string;
    filterValue: any;
  }[];
}) => {
  const params = new URLSearchParams();

  if (search) params.append("search", search);

  // -----------------------------
  // Build structured filters body
  // -----------------------------
  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await Axios.post(
    `${API_ENDPOINT?.PURCHASE_MANAGEMENT?.PURCHASE_REQUEST?.EXPORT}?${params.toString()}`,
    body,
    { responseType: "blob" }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") ||
      `purchase_request_${new Date().toISOString().split("T")[0]}.csv`,
  };
};


export const fetchPurchaseRequestId = createAsyncThunk(
  "pr/fetchPurchaseRequestId",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(
        `${API_ENDPOINT?.PURCHASE_MANAGEMENT?.PURCHASE_REQUEST?.DETAIL(id)}`
      );
      return response?.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch purchase Request by ID"
      );
    }
  }
);

export const fetchPurchaseRequestDropdown = createAsyncThunk(
  "pr/fetchPurchaseRequestDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_ENDPOINT?.PURCHASE_MANAGEMENT?.PURCHASE_REQUEST?.DROPDOWN}`
      );
      return response?.data?.data || [];
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch purchase Request Dropdown"
      );
    }
  }
);

export const updatePurchaseRequest = createAsyncThunk(
  "pr/updatePurchaseRequest",
  async ({ formData: data, pr_id }: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `${API_ENDPOINT?.PURCHASE_MANAGEMENT?.PURCHASE_REQUEST?.UPDATE(pr_id)}`,
        data
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update purchase Request");
    }
  }
);

export const updateStatusPurchaseRequest = createAsyncThunk(
  "pr/updateStatusPurchaseRequest",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.patch(
        `${API_ENDPOINT?.PURCHASE_MANAGEMENT?.PURCHASE_REQUEST?.STATUS_UPDATE(id)}`
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update PR status"
      );
    }
  }
);



export const addPurchaseRequest = createAsyncThunk(
  "pr/addPurchaseRequest",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(
        `${API_ENDPOINT?.PURCHASE_MANAGEMENT?.PURCHASE_REQUEST?.CREATE}`,
        data
      );
      return response?.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add PR");
    }
  }
);
export const approveRejectPurchaseRequest = createAsyncThunk(
  "pr/approveRejectPurchaseRequest",
  async (
    {
      pr_id,
      action,
      remark,
    }: { pr_id: string; action: "approve" | "reject"; remark?: string },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await Axios.post(
        API_ENDPOINT?.PURCHASE_MANAGEMENT?.PURCHASE_REQUEST?.APPROVE_REJECT_PR(
          pr_id
        ),
        { action, remark }
      );
      return response?.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to process PR approval"
      );
    }
  }
);

export const fetchPRAnalytics = createAsyncThunk(
  "pr/fetchPRAnalytics",
  async (_, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(
        `${API_ENDPOINT?.PURCHASE_MANAGEMENT?.PURCHASE_REQUEST?.PR_ANALYTICS}`
      );
      return response?.data?.data || response?.data || [];
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch PR analytics"
      );
    }
  }
);
